module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box box-body"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "billNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Assign No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.assignNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "margin-left": "-8%"
    },
    attrs: {
      "id": "purchaseDate"
    }
  }, [_c('label', {
    attrs: {
      "for": "purchaseDate"
    }
  }, [_vm._v("Assign From :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput"
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.assignFromDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 ",
    staticStyle: {
      "margin-left": "-5%"
    },
    attrs: {
      "id": "purchaseDate1"
    }
  }, [_c('label', {
    attrs: {
      "for": "purchaseDate1"
    }
  }, [_vm._v("Assign To :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.assignToDate) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 ",
    staticStyle: {
      "margin-left": "-5%"
    },
    attrs: {
      "id": "warehouseName"
    }
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Store :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.warehouse.name) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Employee :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.purchaseHeaderObj.employee.name))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.assignDetailList), function(pd, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.quantity))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchaseHeaderObj.remarks),
      expression: "purchaseHeaderObj.remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.purchaseHeaderObj.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.purchaseHeaderObj, "remarks", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "margin-top": "12%"
    }
  }, [_c('Button', {
    staticClass: "p-button-raised",
    staticStyle: {
      "margin-top": "10px",
      "float": "right",
      "margin-left": "100%"
    },
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Back"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Contact :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "suppplier"
    }
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Address :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9b3ef0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/InventoryAssign/assignDetails.vue
// module id = 2378
// module chunks = 0